<div class="banner-container">
	<div class="heading">{{ headingText }}</div>
	<div class="action-text">Click below to go home</div>
	<div class="action-button">
		<button type="button" class="btn btn-primary" routerLink="/">Home</button>
	</div>
</div>
